import styles from "./Error.module.css"
import errorImage from "../../asset/images/errorImage.png";
import { useEffect } from 'react';
import { track, EVENTS } from '../../utils/analyticsService';


export const ErrorFallback = ({ error, errorInfo, errorDetails })=>{
    // Handle different usage patterns:
    // 1. React Error Boundary: { error, errorInfo } props
    // 2. Manual usage: { errorDetails } prop or no props
    const actualError = error || errorDetails?.error || new Error('Manual error state triggered');
    const actualErrorInfo = errorInfo || errorDetails?.errorInfo || {};
    
    const message = actualError?.message || actualError?.error?.message || 'Unknown error occurred';
    console.log('err', message)
    
    // error_shown: where and what kind, never the raw response body or any
    // storage contents (those can carry personal data).
    useEffect(() => {
        const isBoundary = !!error && !errorDetails; // react-error-boundary passes { error }
        const status = actualError?.status || actualError?.response?.status || null;
        track(EVENTS.ERROR_SHOWN, {
            context: actualErrorInfo?.error_context || (isBoundary ? 'error_boundary' : 'error_screen'),
            reason: String(actualError?.name || 'Error').slice(0, 60),
            message: String(message || '').slice(0, 120),
            http_status: status,
            path: window.location.pathname,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message]);

    return(
        // <div>
        //     <p style={{color: 'white'}}>Something went wrong:</p>
        //     <pre style={{color: 'red'}}>{message || ''}</pre>
        // </div>
        <div className={styles.errorScreen}>
            <div className={styles.content}>
                <img className={styles.errorImage} src={errorImage} alt="errorImage" />
                <p className={styles.headerText}>Oops, some error occured!</p>
                <p className={styles.subText}>Please try to reload the app.</p>
                <button onClick={() => {
                    window.location.reload();
                }} className={styles.button} >RELOAD APP</button>
            </div>
        </div>
    )
}

// Helper function for manual error states with context
export const createErrorFallback = (context = {}) => {
    const { 
        errorMessage = 'Data loading failed', 
        errorSource = 'API_ERROR',
        componentName = 'Unknown Component',
        additionalContext = {}
    } = context;
    
    const syntheticError = new Error(errorMessage);
    syntheticError.name = errorSource;
    syntheticError.source = 'manual_error_state';
    
    const errorInfo = {
        componentStack: `Error in ${componentName}`,
        errorBoundary: false,
        ...additionalContext
    };
    
    return <ErrorFallback errorDetails={{ error: syntheticError, errorInfo }} />;
};

// Helper function to create error details from caught exceptions
export const createErrorDetails = (error, context = {}) => {
    const {
        componentName = 'Unknown Component',
        errorContext = 'unknown_operation',
        apiCallsAttempted = [],
        additionalContext = {}
    } = context;
    
    // Serialize error object to ensure it can be properly transmitted
    const serializeError = (err) => {
        if (!err) return null;
        
        // If it's already a plain object, return as is
        if (err.constructor === Object) return err;
        
        // For Error objects, extract key properties
        if (err instanceof Error) {
            return {
                message: err.message,
                name: err.name,
                stack: err.stack,
                constructor: err.constructor.name,
                // Include any custom properties
                ...Object.getOwnPropertyNames(err).reduce((acc, key) => {
                    if (!['message', 'name', 'stack'].includes(key)) {
                        acc[key] = err[key];
                    }
                    return acc;
                }, {})
            };
        }
        
        // For other objects, try to serialize safely
        try {
            return JSON.parse(JSON.stringify(err));
        } catch {
            return { message: String(err), serialization_error: true };
        }
    };
    
    return {
        error: serializeError(error),
        errorInfo: {
            componentStack: `Error in ${componentName}`,
            error_context: errorContext,
            api_calls_attempted: apiCallsAttempted,
            timestamp: new Date().toISOString(),
            ...additionalContext
        }
    };
};